module.exports = __webpack_public_path__ + "img/lg_ring_r_e_1_0@2x.a4c1997d.png";